module.exports = __webpack_public_path__ + "static/media/cross.7b394c8e.svg";